import React from 'react';
import SuiviHeader from '../../../composants/SuiviHeader/SuiviHeader';
import { getStatusColor } from '../../../utils/entityUtils';
import { CommandeBC } from '../types';

interface CommandeHeaderProps {
  titre: string;
  sousTitre: string;
  subtitle: string;
  commande: CommandeBC;
  backgroundImage?: string;
}

// Banniere prestataire-BC : delegue au generique SuiviHeader (meme composant et meme rendu DOM
// que la case acheteur operation-bc, config source="BC") pour une parite VISUELLE exacte.
// SuiviHeader gere EN INTERNE l'expiration (source="BC", statusId=9), le libelle "À relancer"
// (statut 12) et le chrono (statut 11) — exactement la logique deja reproduite dans le domaine
// commandeStatus. Le libelle/couleur du statut viennent du nom + getStatusColor (id-based cote
// expiration via statusId). On garde les props existantes (titre/sousTitre/subtitle/commande/
// backgroundImage) : le shell appelant reste inchange.
const CommandeHeader: React.FC<CommandeHeaderProps> = ({
  titre,
  sousTitre,
  subtitle,
  commande,
  backgroundImage,
}) => (
  <SuiviHeader
    titre={titre}
    sousTitre={sousTitre}
    // Parite avec le presta MS (CommandeMsHeader) : ouvrage en titre principal. Le presta ne
    // saisit rien ici, donc pas de buffer d'edition a suivre — valeur persistee uniquement.
    nomOuvrage={commande.operation?.nom_ouvrage || undefined}
    subtitle={subtitle}
    status={commande.status?.nom || 'Statut inconnu'}
    statusColor={getStatusColor(commande.status?.nom || '')}
    delais={commande.expire_at ?? undefined}
    backgroundImage={backgroundImage}
    source="BC"
    statusId={commande.status?.id}
    encart={{
      operationId: commande.operation?.id,
      numeroMarche: String(commande.operation?.numero ?? ''),
      sensibilite: commande.operation?.niveau_sensibilite || null,
    }}
  />
);

export default CommandeHeader;
